/**
 * Sends an issue report attachment straight to the presigned S3 URL the service issued.
 *
 * Files up to 80 MB do not fit in a request to the service, so the browser uploads the bytes itself.
 * It uses plain fetch because the shared API client signs every request with SigV4, and S3 rejects a
 * request that carries an Authorization header next to a presigned URL.
 */

export interface AttachmentFilePut {
  readonly url: string;
  readonly file: File;
  readonly contentType: string;
}

/** Resolves to whether storage accepted the file; a network failure counts as not accepted. */
export async function putAttachmentFile ({ url, file, contentType }: AttachmentFilePut): Promise<boolean> {
  try {
    const response = await fetch(url, { method: 'PUT', headers: { 'Content-Type': contentType }, body: file });
    return response.ok;
  } catch {
    return false;
  }
}
